import React from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { IconArrowLeft } from "@velaro/velaro-component-lib/";
import IconByName from "@/components/ds/IconByName";

export default function MagentoOverview() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 border-slate-300 relative mr-4 rounded border p-2 content-center flex items-center justify-center">
            <img src="/img/magento.svg" alt="Magento" className="w-10 h-10" />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">Magento / Adobe Commerce</div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Connect Magento to look up customers, orders, products, and B2B data during live chats.
            </div>
          </div>
        </div>
        <PrimaryBlueButton
          label="Connect Magento"
          onClick={() => navigate("/integrations/magento/create")}
          prefixIcon={null}
          className="font-medium"
        />
      </div>

      <div className="flex border-b mb-4">
        <div className="py-2 mr-4 cursor-pointer text-slate-800 text-sm border-b-2 border-b-slate-600 px-3">
          Overview
        </div>
      </div>

      <div className="text-sm text-slate-800 space-y-3">
        <p>
          Connect Magento or Adobe Commerce so your support agents can instantly pull up customer accounts, order history, and product details during live conversations — without leaving Velaro.
        </p>
        <p>
          AI workflow nodes can query your Magento store to look up orders by ID, search customers by email, check stock levels, and retrieve product information automatically during automated flows.
        </p>
        <p>
          Adobe Commerce (B2B) users get additional tools: company account lookups, requisition list management, and negotiable quote support — all accessible through AI workflows.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { title: "Customer Lookup", desc: "Search Magento customers by email or name during live chats. See account details, order count, and addresses.", icon: "ShoppingCart" },
          { title: "Order & Tracking", desc: "Pull up order status, tracking info, and recent purchases so agents can resolve support questions instantly.", icon: "Package" },
          { title: "B2B Commerce", desc: "Adobe Commerce users: company accounts, requisition lists, and negotiable quotes — all via AI workflows.", icon: "Building" }
        ].map((f) => (
          <div key={f.title} className="rounded-lg border border-slate-200 p-4">
            <div className="mb-2"><IconByName name={f.icon} className="w-6 h-6" /></div>
            <div className="font-medium text-slate-800 text-sm mb-1">{f.title}</div>
            <div className="text-xs text-slate-500">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function MagentoBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations")}>
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}

export function MagentoBackToOverview() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations/magento/overview")}>
      <IconArrowLeft className="h-6 w-6" />
      Back to Magento
    </div>
  );
}
